import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import OurLayouts from './layout/index';

const AddAddress = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { patientCode } = location.state || {};
  console.log(patientCode, "patientCode");
  const [fetchedState, setFetchedState] = useState("");
  const [fetchedCity, setFetchedCity] = useState("");
  const [fetchedCountry, setFetchedCountry] = useState("");
  const [houseNo, setHouseNo] = useState("");
  const [address1, setAddress1] = useState("");
  const [landmark, setLandmark] = useState("");
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [stateField, setStateField] = useState("");
  const [formData, setFormData] = useState({
    houseNo: '',
    address: '',
    pincode: '',
    area: '',
    state: '',
    country: ''
  });
  
  const [areaOptions, setAreaOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const API_URL = process.env.REACT_APP_API_URL;

  // Validation functions
  const validateField = (fieldName, value) => {
    let error = '';
    
    switch (fieldName) {
      case 'houseNo':
        if (!value.trim()) {
          error = 'House number is required';
        } else if (value.trim().length < 2) {
          error = 'House number must be at least 2 characters';
        }
        break;
      case 'address1':
        if (!value.trim()) {
          error = 'Landmark is required';
        } else if (value.trim().length < 3) {
          error = 'Landmark must be at least 3 characters';
        }
        break;
      case 'pincode':
        if (!value.trim()) {
          error = 'Pincode is required';
        } else if (!/^\d{6}$/.test(value)) {
          error = 'Pincode must be exactly 6 digits';
        }
        break;
      default:
        break;
    }
    
    setErrors(prev => ({
      ...prev,
      [fieldName]: error
    }));
    
    return error;
  };

  const validateForm = () => {
    const houseNoError = validateField('houseNo', houseNo);
    const address1Error = validateField('address1', address1);
    const pincodeError = validateField('pincode', pincode);
    
    return !houseNoError && !address1Error && !pincodeError;
  };

  const fetchAddressByPincode = async (pincode) => {
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      
      const response = await axios.get(
        `${process.env.REACT_APP_NEWBASEURL}getAllAddressDetails/list?pincode=${pincode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      
      console.log("Address API response:", response.data.data);
      
      if (response.data.data && response.data.data.length > 0) {
        const addressData = response.data.data[0]; // Take first entry since all have same state/district
        
        // Create area options for dropdown
        const areas = response.data.data.map(item => ({
          value: item.area,
          label: item.area,
          key: item.area
        }));
        setAreaOptions(areas);
        
        // Update state variables
        setFetchedState(addressData.state || "");
        setFetchedCity(addressData.area || ""); // Using area as city
        setFetchedCountry("India");
        
        // Update form fields
        setStateField(addressData.state || "");
        setCity(addressData.area || "");
        
        console.log("Address fields updated:", {
          state: addressData.state,
          city: addressData.area,
          country: "India"
        });
      }
    } catch (error) {
      console.error("Error fetching address details:", error);
      toast.error("Failed to fetch address details");
    }
  };
  // Fetch area options when pincode is entered
  const fetchAreaByPincode = async (pincode) => {
    if (pincode.length === 6) {
      try {
        const response = await axios.get(`${API_URL}area/pincode/${pincode}`);
        setAreaOptions(response.data || []);
      } catch (error) {
        console.error('Error fetching area data:', error);
        setAreaOptions([]);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Auto-fetch area when pincode is entered
    if (name === 'pincode' && value.length === 6) {
      fetchAreaByPincode(value);
    }
  };

  const handleAddressConfirm = async () => {
    // Validate form before proceeding
    if (!validateForm()) {
      toast.error("Please fix the validation errors before submitting");
      return;
    }

    try {
    
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
    
      
        // 3. Common address payload
       const payload = {
            address: houseNo,
            landmark: address1,
          // deliveryLandmark: landmark,
        //   deliveryCity: city,
          state: fetchedState || stateField,
          pincode: pincode,
          country: fetchedCountry || "India",
          patientId: patientCode,
        };
   
      
        const res = await fetch(
          `${API_URL}addressbook`,
          {
            method: "POST",
            headers: { 
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`, 
                tenantId: tenantId 
              },
            body: JSON.stringify(payload),
          }
        );

        console.log("Response status:", res.status);
        
        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          console.error("API Error:", errorData);
          throw new Error(`HTTP error! status: ${res.status}, message: ${errorData.message || 'Unknown error'}`);
        }

        const responseData = await res.json();
        console.log("Success response:", responseData);
        
        // Check if address was created successfully by looking for id field
        if (responseData && responseData.id) {
          toast.success("Address added successfully!");
          console.log("Address created with ID:", responseData.id);
          
          // Reset all form fields
          setHouseNo("");
          setAddress1("");
          setLandmark("");
          setPincode("");
          setCity("");
          setStateField("");
          setFetchedState("");
          setFetchedCity("");
          setFetchedCountry("");
          setAreaOptions([]);
          setErrors({});
          
          // Reset form data object
          setFormData({
            houseNo: '',
            address: '',
            pincode: '',
            area: '',
            state: '',
            country: ''
          });
        } else {
          // Response doesn't have expected structure
          console.error("Unexpected response structure:", responseData);
          toast.error("Address creation failed - unexpected response");
        }
     
    
    } catch (err) {
      console.error("handleAddressConfirm error:", err);
      toast.error(err.message || "Failed to update address");
    }
  };

  return (
    <OurLayouts>
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-2xl mx-auto px-4">
          {/* Header Section */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Add Address</h1>
            <p className="text-gray-600">Please provide the complete address details</p>
          </div>

          {/* Form Section */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="space-y-6">
              {/* House no | Apartment name */}
              <div>
                <input
                  type="text"
                  placeholder="House no | Apartment name *"
                  className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                    errors.houseNo 
                      ? 'border-red-500 focus:ring-red-500' 
                      : 'border-gray-300 focus:ring-blue-500'
                  }`}
                  value={houseNo}
                  onChange={(e) => {
                    setHouseNo(e.target.value);
                    if (errors.houseNo) {
                      validateField('houseNo', e.target.value);
                    }
                  }}
                  onBlur={(e) => validateField('houseNo', e.target.value)}
                  required
                />
                {errors.houseNo && (
                  <p className="text-red-500 text-sm mt-1">{errors.houseNo}</p>
                )}
              </div>

              {/* Address */}
              <div>
                <input
                  type="text"
                  placeholder="Landmark *"
                  className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                    errors.address1 
                      ? 'border-red-500 focus:ring-red-500' 
                      : 'border-gray-300 focus:ring-blue-500'
                  }`}
                  value={address1}
                  onChange={(e) => {
                    setAddress1(e.target.value);
                    if (errors.address1) {
                      validateField('address1', e.target.value);
                    }
                  }}
                  onBlur={(e) => validateField('address1', e.target.value)}
                  required
                />
                {errors.address1 && (
                  <p className="text-red-500 text-sm mt-1">{errors.address1}</p>
                )}
              </div>

              {/* Pincode */}
              <div>
                <input
                  type="text"
                  placeholder="Pincode *"
                  className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                    errors.pincode 
                      ? 'border-red-500 focus:ring-red-500' 
                      : 'border-gray-300 focus:ring-blue-500'
                  }`}
                  value={pincode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
                    setPincode(value);
                    if (errors.pincode) {
                      validateField('pincode', value);
                    }
                    // Auto-fetch address details when pincode is 6 digits
                    if (value.length === 6) {
                      fetchAddressByPincode(value);
                    }
                  }}
                  onBlur={(e) => validateField('pincode', e.target.value)}
                  maxLength={6}
                  required
                />
                {errors.pincode && (
                  <p className="text-red-500 text-sm mt-1">{errors.pincode}</p>
                )}
              </div>
             
            
              <div className="flex space-x-4">
              
              
                <div className="flex-1 relative">
                <input
                  type="text"
                  placeholder="State *"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-500 bg-gray-50 focus:outline-none transition-all duration-200"
                  value={fetchedState}
                  readOnly
                />
                </div>
                
                {/* <div className="flex-1 relative">
                  <select
                    className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 appearance-none bg-white"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    required
                  >
                    <option value="">Select Area</option>
                    {areaOptions.map((area) => (
                      <option key={area.key} value={area.value}>
                        {area.label}
                      </option>
                    ))}
                  </select>
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div> */}
              </div>

              {/* State */}
              {/* <div>
                <input
                  type="text"
                  placeholder="State *"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-500 bg-gray-50 focus:outline-none transition-all duration-200"
                  value={fetchedState}
                  readOnly
                />
              </div> */}

              {/* Country */}
              <div>
                <input
                  type="text"
                  placeholder="Country *"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-500 bg-gray-50 focus:outline-none transition-all duration-200"
                  value={fetchedCountry}
                  readOnly
                />
              </div>

              {/* Submit Button */}
              <div className="flex justify-center pt-6 border-t border-gray-200">
                {/* <button
                  type="button"
                  onClick={handleAddressConfirm}
                  disabled={loading}
                  className="px-8 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-sm hover:shadow-md"
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button> */}
                <button 
                 onClick={handleAddressConfirm}
                 disabled={loading}
                 className=" py-3 px-20 rounded-xl font-semibold mb-4 flex items-center justify-center gap-2 transition-all duration-300 bg-gradient-to-r from-[#004172] to-[#3cba84] text-white hover:shadow-lg hover:scale-105">
                {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </OurLayouts>
  );
};

export default AddAddress;
